import * as z from "zod";

export const startAutomationOutreachSplit = {
  name: "startAutomationOutreachSplit" as const,
  input: z.object({ splitId: z.string() }),
  output: z.object({ success: z.boolean() }),
};
